export const LABEL_VISIBILITY = {
  SYSTEM: 'system',
  TEAM: 'team',
  INBOX: 'inbox',
};

// Marcador pode ser aplicado na conversa: equipe segue o usuário (admin vê
// todas), caixa segue a caixa da conversa.
export const isLabelAvailableForConversation = (
  label,
  conversation,
  { isAdmin = false, teamIds = [] } = {}
) => {
  const visibility = label?.visibility || LABEL_VISIBILITY.SYSTEM;
  if (visibility === LABEL_VISIBILITY.SYSTEM) return true;
  if (visibility === LABEL_VISIBILITY.TEAM) {
    return isAdmin || teamIds.includes(label.team_id);
  }
  if (!conversation) return false;
  if (visibility === LABEL_VISIBILITY.INBOX) {
    return !!label.inbox_id && label.inbox_id === conversation.inbox_id;
  }
  return false;
};

export const filterLabelsForConversations = (
  labels,
  conversations = [],
  userContext = {}
) =>
  labels.filter(label =>
    conversations.every(conversation =>
      isLabelAvailableForConversation(label, conversation, userContext)
    )
  );

// Marcador visível para o usuário: admin vê todos; agente vê os de sistema
// e os das equipes/caixas das quais participa.
export const isLabelVisibleForUser = (
  label,
  { isAdmin = false, teamIds = [], inboxIds = [] } = {}
) => {
  const visibility = label?.visibility || LABEL_VISIBILITY.SYSTEM;
  if (isAdmin || visibility === LABEL_VISIBILITY.SYSTEM) return true;
  if (visibility === LABEL_VISIBILITY.TEAM)
    return teamIds.includes(label.team_id);
  if (visibility === LABEL_VISIBILITY.INBOX) {
    return inboxIds.includes(label.inbox_id);
  }
  return false;
};
